export default __webpack_public_path__ + "static/media/image-car.3d22a420.webp";